import {
  Base,
  Component,
  InjectReactive,
  Mixins,
  Watch
} from '@/vue-property-decorator'
import { GetCssVarManager } from '../../../../components/baseCssVarProvide'
import { _LoneStarBase as LoneStarBase } from './cssVar/loneStarBase'
import { _LoneStarDefault as LoneStarDefault } from './cssVar/loneStarDefault'
import BaseCssVarInject from '../../../../components/baseCssVarInject'
import IconAnimation from '../components/iconAnimation'
import style from './style.module.scss'
export { LoneStarBase, LoneStarDefault }
export type LoneStarCssVarManager = GetCssVarManager<LoneStarBase>
/** 单个的星型图标 */
@Component<LoneStar>({
  name: 'LoneStar'
})
export default class LoneStar extends Mixins<
  Base,
  BaseCssVarInject<LoneStarBase>
>(Base, BaseCssVarInject) {
  public static getLoneStarDefault = () => new LoneStarDefault()

  @InjectReactive()
  private isFavorited!: boolean

  /** 是否展示动画 */
  private isShowAnimation = false

  @Watch('isFavorited')
  protected changeIsShowAnimation(it: boolean, old: boolean) {
    // 只有当选中状态,从false变为true时,才显示动画,其它时间都不展示动画的.
    if (it === true && old === false) {
      this.isShowAnimation = true
    } else {
      this.isShowAnimation = false
    }
  }

  /** 最终呈现的已收藏状态的图标 */
  private get collectedIcon() {
    if (this.isShowAnimation) {
      return (
        <IconAnimation
          cssVarManagerMust={{
            '--icon-animation-transform': 'scale(1.4)'
          }}
          iconUrl="/lobby_asset/common/web/home/bookmark_star_1.png"
        ></IconAnimation>
      )
    } else {
      return (
        <my-img
          class={style['img-div']}
          src="/lobby_asset/common/common/home/btn_sc_on.png"
          options={{ type: 'div' }}
        />
      )
    }
  }

  render() {
    return (
      <div
        class={{
          [style['lone-star']]: true,
          [style[`type-${this.finialCssType}`]]: Boolean(this.finialCssType)
        }}
      >
        {this.isFavorited ? (
          this.collectedIcon
        ) : (
          <my-img
            class={style['img-div']}
            src="/lobby_asset/common/common/home/btn_sc_off.png"
            options={{ type: 'div' }}
          />
        )}
      </div>
    )
  }
}
